<script lang="ts">
/**
 * @component FingerprintTracker
 *
 * Consent-gated Fingerprint browser identification component.
 * Wraps the Fingerprint Svelte SDK's `FingerprintProvider` and renders
 * `FingerprintIdentifier` as a child to perform the actual identification.
 *
 * This component should be rendered inside a `ConsentWrapper` with
 * `category="tracking"` so that the Fingerprint SDK script is only loaded
 * after the user grants tracking consent.
 *
 * @example
 * ```svelte
 * <ConsentWrapper category="tracking">
 *   <FingerprintTracker />
 * </ConsentWrapper>
 * ```
 *
 * @see {@link ConsentWrapper} for consent-gated rendering
 * @see {@link GoogleAnalytics} for the GA4 integration this feeds into
 * @see https://docs.fingerprint.com/docs/svelte for SDK documentation
 */
import { FingerprintProvider } from "@fingerprint/svelte";
import { PUBLIC_FINGERPRINT_API_KEY } from "$app/env/public";
import FingerprintIdentifier from "./FingerprintIdentifier.svelte";
</script>

<FingerprintProvider
  options={{
    apiKey: PUBLIC_FINGERPRINT_API_KEY,
    region: "eu",
    endpoints: [
      "https://analytics.comboompunktsucht.app",
      "https://analytics.mcpeapsunterstrichhd.dev",
    ],
  }}
>
  <FingerprintIdentifier />
</FingerprintProvider>
